import { apiClient } from "@nabble/sdk";
import { useEffect, useState } from "react";
import { errorMessage } from "../../../errors";
import { type MfaMethod, sortMethods } from "./mfaMethods";

export interface MfaMethods {
  /** `null` while loading; empty when they couldn't be loaded. */
  methods: MfaMethod[] | null;
  selected: MfaMethod | null;
  select: (method: MfaMethod) => void;
  loadError: string | null;
}

/** The second factors the person can use now, with the first one selected. */
export function useMfaMethods(): MfaMethods {
  const [methods, setMethods] = useState<MfaMethod[] | null>(null);
  const [selected, setSelected] = useState<MfaMethod | null>(null);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    apiClient<{ methods: MfaMethod[] }>("/api/auth/mfa/methods")
      .then((data) => {
        const sorted = sortMethods(data.methods);
        setMethods(sorted);
        setSelected(sorted[0] ?? null);
      })
      .catch((err: unknown) => {
        setMethods([]);
        setLoadError(errorMessage(err, "We couldn't load the verification methods."));
      });
  }, []);

  return { methods, selected, select: setSelected, loadError };
}
